export default __webpack_public_path__ + "static/media/smartview.2054ab48.png";